/*
  Project: AP_Chisel
  Author: Luum GmbH
 */

import main from './modules/main';


main();




// WEBPACK FOOTER //
// ./src/scripts/app.js